/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Commission_RangeInputs */

const en_clients_validation_commission_range = /** @type {(inputs: Clients_Validation_Commission_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commission fee must be between 0 and 100.`)
};

const pt_br2_clients_validation_commission_range = /** @type {(inputs: Clients_Validation_Commission_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A comissão deve ser entre 0 e 100.`)
};

/**
* | output |
* | --- |
* | "Commission fee must be between 0 and 100." |
*
* @param {Clients_Validation_Commission_RangeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_commission_range = /** @type {((inputs?: Clients_Validation_Commission_RangeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Commission_RangeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_commission_range(inputs)
	return pt_br2_clients_validation_commission_range(inputs)
});